module.exports = __webpack_public_path__ + "img/BG130598160.d784bcfd.png";